import { defineComponent, h, VNodeChildren } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { VNodeData } from 'vue/types/vnode.d';
import { ScimErrorLog } from '@/services/api/resources/sso-configuration';

interface ContentProps {
  log: ScimErrorLog;
}

export const Content = defineComponent<ContentProps>({
  name: 'Content',
  props: ['log'],
  setup(props) {
    return function render() {
      return h('span', { class: 'sso-scim-error-logs__content' }, [t(props.log.message)]);
    };
  },
});

export function content(data: VNodeData & { props: ContentProps }, children: VNodeChildren = []) {
  return h(Content, data, children);
}
